import { IApplicationLink, IApplicationRoutes } from 'ops-lib';

const NAMESPACE = 'PARAMS';
const INITIAL_STATE: AppState = {
  navigationLinks: null, // <Array<IApplicationLink>>{},
  applicationRoutes: <Array<IApplicationRoutes>>{},
  reloadData: null,
  version: null
};

export const AppActions = {
  INIT: `${NAMESPACE}.INIT`,
  SET_APP_ID: `${NAMESPACE}.SET_APP_ID`,
  SET_NAVIGATION: `${NAMESPACE}.SET_NAVIGATION`,
  SET_EXTERNAL_ROUTES: `${NAMESPACE}.SET_EXTERNAL_ROUTES`,
  RELOAD_DATA: `${NAMESPACE}.RELOAD_DATA`,
  SET_APP_VERSION: `${NAMESPACE}.SET_APP_VERSION`,
};

export function AppReducer(state: AppState = INITIAL_STATE, action: any) {
  switch (action.type) {
    case AppActions.INIT:
      state = INITIAL_STATE;
      return state;
    case AppActions.SET_NAVIGATION:
      state.navigationLinks = action.payload;
      return state;
    case AppActions.SET_EXTERNAL_ROUTES:
      state.applicationRoutes = action.payload;
      return state;
    case AppActions.RELOAD_DATA:
      state.reloadData = action.payload;
      return state;
    case AppActions.SET_APP_VERSION:
        state.version = action.payload;
        return state;
    default:
      return state;
  }
}

export interface AppState {
  navigationLinks: Array<IApplicationLink>;
  applicationRoutes: Array<IApplicationRoutes>;
  reloadData: boolean;
  version: string;
}
